<template>
    <div v-if="series !== null">
        <page-header :title="$t('pages.admin.series.management.title') + ': ' + series.title[$i18n.locale]" icon-class="mdi mdi-television">
            <div class="text-right">
                <a @click="$refs.addVideoModal.open();" class="cursor-pointer text-primary font-weight-bold">
                    <i class="mdi mdi-plus"></i> {{ $t('pages.admin.series.management.add_video') }}
                </a>
            </div>
        </page-header>

        <div class="row">
            <div class="col">
                <div class="alert alert-secondary border-dark">
                    {{ $t('pages.admin.series.management.explanation') }}
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-3 stretch-card grid-margin" v-for="video in videos" :key="video.id">
                <gym-video-card :video="video" :show-progress="false"
                                :show-like="false" :show-completed="false"
                                :hover-effect-enabled="false" :key="video.id">

                    <template v-slot:footer>
                        <div class="card-footer pl-4 pr-4">
                            <button class="btn btn-danger btn-sm" @click="removeVideoFromSeries(video.id)">
                                <i class="mdi mdi-close"></i>
                            </button>
                        </div>
                    </template>
                </gym-video-card>
            </div>
        </div>

        <sweet-modal ref="addVideoModal" @open="addVideoModalOpened = true" @close="addVideoModalOpened = false"  width="80%" :title="$t('pages.admin.series.management.add_video')">
            <video-selector v-if="addVideoModalOpened" :excluded-series-id="series.id" @select="addVideoToSeries"></video-selector>
        </sweet-modal>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
import GymVideoCard from "../../Gym/Includes/GymVideoCard";
import { SweetModal } from 'sweet-modal-vue'
import VideoSelector from "../Video/Includes/VideoSelector";

export default {
    name: "SeriesVideoManagement",
    components: {VideoSelector, GymVideoCard, PageHeader, SweetModal},
    data: () => ({
        series: null,
        videos: [],

        addVideoModalOpened: false,
    }),
    mounted() {
        this.getSeriesVideos();
    },
    methods: {
        addVideoToSeries(video) {
            AdminSeriesRepository
                .addVideo(this.$route.params.slug, video)
                .then((res) => {
                    this
                        .getSeriesVideos()
                        .then((res) => {
                            this.$snotify.success(this.$t('actions.added'));
                            this.$refs.addVideoModal.close();
                        })
                })
        },

        removeVideoFromSeries(video) {
            AdminSeriesRepository
                .removeVideo(this.$route.params.slug, video)
                .then((res) => {
                    this.videos = this.videos.filter(v => v.id !== video);
                    this.$snotify.success(this.$t('actions.removed'));
                })
        },

        getSeriesVideos() {
            return AdminSeriesRepository
                .getSeries(this.$route.params.slug)
                .then((res) => {
                    this.series = res.data;
                    this.videos = res.data.videos;
                });
        }
    },
}
</script>

<style scoped>

</style>
